<div class="hc-page-heading" [class.hc-page-heading--main]="variant === 'main'" [class.hc-page-heading--subpage]="variant === 'subpage'">
  <div class="hc-page-heading__left">
    @if (variant === 'subpage') {
      @if (backRoute) {
        <a [routerLink]="backRoute" class="hc-page-heading__back">
          <hc-button variant="secondary" leftIcon="arrow-left">{{ backLabel }}</hc-button>
        </a>
      } @else {
        <hc-button variant="secondary" leftIcon="arrow-left" (clicked)="onBack()">{{ backLabel }}</hc-button>
      }
    }
    <div class="hc-page-heading__title-group">
      <h1 class="hc-page-heading__title">
        @if (title) {
          {{ title }}
        } @else {
          <ng-content></ng-content>
        }
      </h1>
      @if (description) {
        <p class="hc-page-heading__description">{{ description }}</p>
      }
    </div>
  </div>
  <div class="hc-page-heading__actions">
    <ng-content select="[pageActions]"></ng-content>
  </div>
</div>
